"use client";

import { AppPageTitle } from "@/widgets";
import WezonDirection from "@/widgets/app/page/directions/WezonDirection";
import { SsgoiTransition } from "@ssgoi/react";

export default function DirectionPage() {
  return (
    <SsgoiTransition id="/app/pages/directions">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        <WezonDirection />
      </div>
    </SsgoiTransition>
  );
}
